export const LENS_CDN = 'https://cdn.loom.com/assets/lens';
